import {
  LIST_ABNORMAL_RISK_LEVEL_REQUEST,
  LIST_ABNORMAL_RISK_LEVEL_SUCCESS,
  LIST_ABNORMAL_RISK_LEVEL_FAIL,
  LIST_ABNORMAL_RISK_LEVEL_SUMMARY_REQUEST,
  LIST_ABNORMAL_RISK_LEVEL_SUMMARY_SUCCESS,
  LIST_ABNORMAL_RISK_LEVEL_SUMMARY_FAIL,
  CREATE_ABNORMAL_RISK_LEVEL_REQUEST,
  CREATE_ABNORMAL_RISK_LEVEL_SUCCESS,
  CREATE_ABNORMAL_RISK_LEVEL_FAIL,
  DETAIL_ABNORMAL_RISK_LEVEL_REQUEST,
  DETAIL_ABNORMAL_RISK_LEVEL_SUCCESS,
  DETAIL_ABNORMAL_RISK_LEVEL_FAIL,
  UPDATE_ABNORMAL_RISK_LEVEL_REQUEST,
  UPDATE_ABNORMAL_RISK_LEVEL_SUCCESS,
  UPDATE_ABNORMAL_RISK_LEVEL_FAIL,
  DELETE_ABNORMAL_RISK_LEVEL_REQUEST,
  DELETE_ABNORMAL_RISK_LEVEL_SUCCESS,
  DELETE_ABNORMAL_RISK_LEVEL_FAIL,
  UPDATE_POSITION_ABNORMAL_RISK_LEVEL_REQUEST,
  UPDATE_POSITION_ABNORMAL_RISK_LEVEL_SUCCESS,
  UPDATE_POSITION_ABNORMAL_RISK_LEVEL_FAIL,
  RESET_ABNORMAL_RISK_LEVEL
} from '../../constants/abnormal-risk-level'

const initialState = {
  loading: false,
  abnormalRiskLevels: [],
  abnormalRiskLevelsSummary: [],
  abnormalRiskLevel: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  },
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  loadingDetail: false,
  loadingPosition: false
}

const abnormalRiskLevelsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_ABNORMAL_RISK_LEVEL_REQUEST:
      return { ...state, loading: true }
    case LIST_ABNORMAL_RISK_LEVEL_SUCCESS:
      return {
        ...state,
        loading: false,
        abnormalRiskLevels: action.payload,
        pageable: action.pageable
      }
    case LIST_ABNORMAL_RISK_LEVEL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        abnormalRiskLevels: action?.dummy
      }
    case LIST_ABNORMAL_RISK_LEVEL_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_ABNORMAL_RISK_LEVEL_SUMMARY_SUCCESS:
      return { ...state, loading: false, abnormalRiskLevelsSummary: action.payload, error: null }
    case LIST_ABNORMAL_RISK_LEVEL_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_ABNORMAL_RISK_LEVEL_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_ABNORMAL_RISK_LEVEL_SUCCESS:
      return { ...state, loadingCreate: false, error: null }
    case CREATE_ABNORMAL_RISK_LEVEL_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_ABNORMAL_RISK_LEVEL_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_ABNORMAL_RISK_LEVEL_SUCCESS:
      return { ...state, loadingDetail: false, error: null, abnormalRiskLevel: action.payload }
    case DETAIL_ABNORMAL_RISK_LEVEL_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_ABNORMAL_RISK_LEVEL_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_ABNORMAL_RISK_LEVEL_SUCCESS:
      return { ...state, loadingUpdate: false, error: null }
    case UPDATE_ABNORMAL_RISK_LEVEL_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_ABNORMAL_RISK_LEVEL_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_ABNORMAL_RISK_LEVEL_SUCCESS:
      const abnormalRiskLevelIdDelete = action.payload
      const abnormalRiskLevelsDelete = [...state.abnormalRiskLevels]

      const indexDelete = abnormalRiskLevelsDelete.findIndex(
        (abnormalRiskLevel) => abnormalRiskLevel.id === abnormalRiskLevelIdDelete
      )
      abnormalRiskLevelsDelete.splice(indexDelete, 1)
      return { ...state, loadingDelete: false, abnormalRiskLevels: abnormalRiskLevelsDelete, error: null }
    case DELETE_ABNORMAL_RISK_LEVEL_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case UPDATE_POSITION_ABNORMAL_RISK_LEVEL_REQUEST:
      return { ...state, loadingPosition: true }
    case UPDATE_POSITION_ABNORMAL_RISK_LEVEL_SUCCESS:
      return { ...state, loadingPosition: false, error: null }
    case UPDATE_POSITION_ABNORMAL_RISK_LEVEL_FAIL:
      return { ...state, loadingPosition: false, error: action.payload }
    case RESET_ABNORMAL_RISK_LEVEL:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default abnormalRiskLevelsReducer
